import React, { Component } from 'react'
import DragDropFunctions from '~/utils/TemplateEditor/dragDropFunctions'

export default class GenericEditable extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        let eleProps = {}
        let elementType = this.props.elementData.type || 'div'

        if (elementType.indexOf('_localVariables_.') >= 0) {
            elementType = DragDropFunctions.lookupLocalVariables(this.props.localVariables, elementType, false, true)
        }

        const Element = elementType || 'div'

        if (this.props.elementData.props) {
            eleProps = DragDropFunctions.generatePropsForStage(
                this.props.elementData.props,
                this.props.globalVariables,
                Element,
                this.props.localVariables
            )
        }
        return <Element {...eleProps}>{this.props.children}</Element>
    }
}
